import React, { useState } from 'react'
import SnackbarProvider from 'src/contexts/Snack'
import { Dashboard } from 'src/Pages/Dashboard Component/Dashboard'
import { darkTheme, lightTheme } from 'src/theme'
import { ThemeProvider } from 'styled-components'

const App = () => {
  const themes: any = {
    light: lightTheme,
    dark: darkTheme,
  }
  const [theme] = useState('light')
  return (
    <ThemeProvider theme={themes[theme]}>
      <SnackbarProvider>
        <Dashboard />
      </SnackbarProvider>
    </ThemeProvider>
  )
}

export { App }
